import styled from "styled-components"


export const PlaceForm = styled.form`
margin: 24px 0;
display: flex;
flex-direction: column;
justify-content: center;
padding: 10px;
background-attachment: #333334;


`

export const PlaceLabel = styled.label`
display: block;
text-align: center;
margin-bottom:8px;
font-size: 20px;
font-family: Arial, Helvetica, sans-serif;
color: #000000;


`

export const PlaceInput = styled.input`
border: none;
background-color: #FFF;
border-radius: 3px;
box-shadow: 0px 2px 5px 0px #4e4a4a2e;
box-sizing: border-box;
width: 100%;
height: 50px;
font-size: 20px;
padding: 20px;

`